import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Button, Image, Text, YoutubeModal } from '@oy/ui';
import { Colors } from '@oy/uicore';
import classNames from 'classnames';
import React, { useState } from 'react';
import { EmptyStateContentType } from '../../type';
import styles from './Contents.module.css';

export const Contents = ({
  imageName,
  article,
  youtube,
  source_page,
}: EmptyStateContentType) => {
  const [showYoutubeModal, setShowYoutubeModal] = useState(false);

  const onClickPlayYoutube = () => {
    setShowYoutubeModal(true);
    AnalyticsManager.instance().track(AnalyticsEvent.click_video_tutorial, {
      source_page,
    });
  };

  return (
    <div className={styles.contents}>
      <div className={styles.mainContent}>
        <div className={styles.image}>
          {/* pic */}
          <Image className={styles.img} name={imageName} />
        </div>
        <div className={styles.article}>
          {/* article */}
          <Text textStyle={Text.Style.BodyLgSemibold}>{article.title}</Text>
          <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK40}>
            {article.description}
          </Text>
          <div className={styles.buttons}>
            {article.primaryButtonName && (
              <Button
                size={Button.Size.Small}
                style={{ width: 'fit-content' }}
                onClick={article.onClickPrimaryButton}
              >
                {article.primaryButtonName}
              </Button>
            )}
            {article.secondaryButtonName && (
              <Button
                buttonType={Button.Type.Outlined}
                size={Button.Size.Small}
                color={Button.Color.Secondary}
                style={{ width: 'fit-content' }}
                onClick={article.onClickSecondaryButton}
              >
                {article.secondaryButtonName}
              </Button>
            )}
          </div>
        </div>
      </div>
      {youtube && (
        <div className={styles.youtube}>
          {/* youtube */}
          <div className={styles.playButton}>
            <Image
              className={classNames(styles.img)}
              name={youtube?.imagePreview}
            />
            <span className={styles.circlePlay} onClick={onClickPlayYoutube}>
              <span className={styles.trianglePlay}></span>
            </span>
          </div>
          <Text textStyle={Text.Style.BodyMdSemibold}>{youtube.title}</Text>
          <YoutubeModal
            show={showYoutubeModal}
            videoId={youtube.videoId}
            onClose={() => setShowYoutubeModal(false)}
          />
        </div>
      )}
    </div>
  );
};
